import { jsPDF } from 'jspdf';
import { Constants, fromPhotos } from '../../../utils';

const generateConductPDF = (data) => {
  const doc = new jsPDF();

  doc.setFontSize(13);

  // Márgenes
  const margin = 20;
  const photoWidth = 30;
  const pageWidth = doc.internal.pageSize.getWidth();
  const mark = pageWidth - 2 * margin;
  const headerWidth = mark - 40;
  const centerX = pageWidth / 2;
  let y = 20;

  // Estilos generales
  doc.setFont('helvetica');
  doc.setFontSize(12);

  // Logo de la institución
  if (data.college_photo) {
    const extension = data.logo?.split('.')?.pop();
    const logo = doc.addImage(fromPhotos(data.college_photo), extension, 10, 15, photoWidth, photoWidth);
    logo.align = 'center';
    logo.scale(0.5);
  }

  // Header centrado
  let country = 'REPÚBLICA BOLIVARIANA DE VENEZUELA';
  let ministry = 'MINISTERIO DEL PODER POPULAR PARA LA EDUCACIÓN';
  let code = `CÓDIGO DEA ${data.college_code || ''}`;

  if (data.college_country_id === Constants.COUNTRIES.COL) {
    country = 'REPÚBLICA DE COLOMBIA';
    ministry = 'MINISTERIO DE EDUCACIÓN NACIONAL';
    code = '';
  }

  let header = 'COUNTRY_NAME\nCOUNTRY_MINISTRY\nCOLLEGE_NAME\nCOLLEGE_ADDRESS\nCOLLEGE_CODE';
  header = header.replace('COUNTRY_NAME', country);
  header = header.replace('COUNTRY_MINISTRY', ministry);
  header = header.replace('COLLEGE_NAME', data.college_name || '');
  header = header.replace('COLLEGE_ADDRESS', data.college_address || '');
  header = header.replace('COLLEGE_CODE', code);
  const headerText = doc.splitTextToSize(header, headerWidth);
  doc.text(headerText, centerX, y, { align: 'center' });

  // Título en negrita y centrado
  doc.setFont(undefined, 'bold');
  const title = 'Constancia de Buena Conducta';
  y += 50;
  doc.text(title, centerX, y, { align: 'center' });

  // Cambiar a texto normal
  doc.setFont(undefined, 'normal');

  // Cuerpo del informe
  let line1 = 'Quien suscribe, Licdo. DIRECTOR_NAME, titular del documento de identidad N° DIRECTOR_DNI hace constar por medio de la presente que el estudiante:';
  line1 = line1.replace('DIRECTOR_NAME', data.director_name || '');
  line1 = line1.replace('DIRECTOR_DNI', data.director_dni || '');
  const line1Text = doc.splitTextToSize(line1, mark);
  y += 20;
  doc.text(line1Text, margin, y);

  const line2 = data.student_full_name;
  y += 20;
  doc.text(line2, centerX, y, { align: 'center' });

  let line3 = 'titular del documento de identidad N° STUDENT_DNI nacido en BORN_COUNTRY el BIRTH_DAY de BIRTH_MONTH de BIRTH_YEAR estudió en esta institución y durante su permanencia demostró CONDUCT_VALUE CONDUCTA.';
  line3 = line3.replace('STUDENT_DNI', data.student_dni || '');
  line3 = line3.replace('BORN_COUNTRY', data.born_country || '');
  line3 = line3.replace('BIRTH_DAY', data.birth_day || '');
  line3 = line3.replace('BIRTH_MONTH', data.birth_month || '');
  line3 = line3.replace('BIRTH_YEAR', data.birth_year || '');
  line3 = line3.replace('CONDUCT_VALUE', data.conduct_value || '');
  const line3Text = doc.splitTextToSize(line3, mark);
  y += 15;
  doc.text(line3Text, margin, y);

  let line4 = 'Constancia que se expide por la parte interesada a los EXP_DAY días del mes de EXP_MONTH de EXP_YEAR.';
  line4 = line4.replace('EXP_DAY', data.exp_day || '');
  line4 = line4.replace('EXP_MONTH', data.exp_month || '');
  line4 = line4.replace('EXP_YEAR', data.exp_year || '');
  const line4Text = doc.splitTextToSize(line4, mark);
  y += 20;
  doc.text(line4Text, margin, y);

  // Footer
  const footer = 'Atentamente';
  y += 35;
  doc.text(footer, centerX, y, { align: 'center' });

  // Guardar el PDF
  doc.save('informe-estudiante.pdf');
};

export default generateConductPDF;
